import apiMiddleware from "../api/apiMiddleware";

export const eventBookings = async (page = 1, search = "") => {
  try {
    const response = await apiMiddleware.get(
      `/event-bookings-supplier?page=${page}${search ? `&search=${search}` : ""}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
